import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53ec6d2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "edit__top"
}
const _hoisted_2 = { class: "edit__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit__divider" }, null, -1))
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  style: {"margin-top":"32px"},
  class: "edit__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_center = _resolveComponent("center")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_BuyingGeneralInfo = _resolveComponent("BuyingGeneralInfo")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_Postbacks = _resolveComponent("Postbacks")!
  const _component_UrlParams = _resolveComponent("UrlParams")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_Streams = _resolveComponent("Streams")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.ready)
      ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_q_spinner, {
              color: "primary",
              size: "3em",
              thickness: 3
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.isNew
          ? _ctx.$t('pages.campaighn.steps.editCampaighn.create')
          : `${_ctx.$t('pages.campaighn.steps.editCampaighn.edit')} ID #${
              _ctx.$route.params.id
            }`), 1),
          _hoisted_3,
          _createVNode(_component_q_btn, {
            disable: _ctx.loading,
            loading: _ctx.loading,
            "no-caps": "",
            class: "q-mb-md",
            "text-color": "dark",
            color: "primary",
            label: _ctx.$t('btn.save'),
            type: "submit",
            onClick: _ctx.onSubmit,
            icon: "save",
            style: {"margin-bottom":"0px"}
          }, null, 8, ["disable", "loading", "label", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_q_tabs, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
            "inline-label": "",
            breakpoint: 0,
            align: "justify",
            "no-caps": "",
            style: {"background-color":"rgb(37, 44, 62)"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tab, {
                name: "general",
                label: _ctx.$t('pages.campaighn.steps.editCampaighn.tabMain')
              }, null, 8, ["label"]),
              _createVNode(_component_q_tab, {
                name: "postbacks",
                label: _ctx.$t('pages.campaighn.steps.editCampaighn.tabPost')
              }, null, 8, ["label"]),
              _createVNode(_component_q_tab, {
                name: "params",
                label: _ctx.$t('pages.campaighn.steps.editCampaighn.tabParam')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_tab_panels, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
              animated: "",
              class: "bg-transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab_panel, { name: "general" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BuyingGeneralInfo, { "default-options": _ctx.defaultOptions }, null, 8, ["default-options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, { name: "postbacks" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Postbacks, { "default-options": _ctx.defaultOptions }, null, 8, ["default-options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, { name: "params" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UrlParams, { "default-options": _ctx.defaultOptions }, null, 8, ["default-options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_Streams, { "default-options": _ctx.defaultOptions }, null, 8, ["default-options"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}